export default "__VITE_ASSET__BdJPWtQR__"